import { render, staticRenderFns } from "./PromoLocation.vue?vue&type=template&id=a18d9080&lang=pug&"
import script from "./PromoLocation.vue?vue&type=script&lang=js&"
export * from "./PromoLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports